// extracted by mini-css-extract-plugin
export default {"imgMarker":"djFro"};